<template>
  <div
    :am-mode="isActive ? 'edit' : 'show'"
    am-param-array-item
    @click="editMode()"
    v-click-outside="showMode"
    ref="params"
    @keyup.esc="showMode"
    tabindex="1"
  >
    <div
      :am-edit="isActive ? '' : null"
      :am-show="isActive ? null : ''"
      :style="`${isOpenTop ? 'bottom: -4px; top: auto;' : ''} ${isOpenRight ? 'right: -4px; left: auto;' : ''}`"
    >
      <div class="_display:flex _flex-wrap:wrap _align-items:center">
        <i-badge
          color="info"
          v-for="(value, key) in data.data"
          :key="key"
          am-param-badge
          class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
        >
          <p class="_margin:0">
            {{ Number(key) ?  `par ${key}` : `${key}`}} = {{ value.join() }}
          </p>
          <div v-if="isActive" class="_margin-left:1/2">
            <svg viewBox="0 0 24 24" am-icon class="_margin-right:1/4" @click="editParam(key)" style="fill: var(--color--secondary-10);">
              <use xlink:href="@/assets/icons.svg#edit" x="0" y="0" width="24" height="24"></use>
            </svg>
            <svg viewBox="0 0 24 24" am-icon @click="delPar(key)" style="fill: var(--color--secondary-10);">
              <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
            </svg>
          </div>
        </i-badge>
        <svg v-if="isActive" viewBox="0 0 24 24" class="_margin:1/4" am-icon @click="addParam()">
          <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
        </svg>
      </div>
      <template v-if="isEdit">
        <hr>
        <div am-edit-param class="_display:inline-flex _align-items:center _margin-bottom:1/2">
          <i-dropdown class="_margin-right:1/2" :disabled="isEdit === 'edit'">
            <div class="_display:flex _align-items:center">
              <p>{{ dropChecked }}</p>
              <i-icon name="ink-caret-down" />
            </div>
            <template #body>
              <i-dropdown-item
                v-for="dropValue in dropValues"
                :key="dropValue"
                :disabled="dropValue === dropChecked"
                @click.prevent="inputCheck(dropValue)"
              >
                {{ dropValue }}
              </i-dropdown-item>
            </template>
          </i-dropdown>
          <i-input
            v-if="dropChecked === 'par'"
            v-model="inputNumber"
            :error="numberEror"
            :disabled="isEdit === 'edit'"
            am-number-input
            type="number"
            placeholder="Number"
          />
          <p class="_margin-left:1/4 _margin-right:1/4">=</p>
        </div>
        <ITextarea
          am-params-textarea
          :style="`height:${heightArea}px;`"
          v-model="inputValue"
          @keypress="watchValue"
          placeholder="Value"
        />
        <p class="_color:danger">{{ errorMessage }}</p>
        <div class="_margin-top:1/2" am-buttons>
          <i-button
            class="_width:50%"
            @click="add()"
            :disabled="disabledSaveButton"
            :color="disabledSaveButton ? '' : 'success'"
          >
            {{ isEdit === 'add' ? 'Add' : 'Save' }}
          </i-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'ParamsItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isActive: false,
    isEdit: false,
    number: null,
    numberEror: false,
    value: null,
    dropValues: ['par', 'завтал', 'waistband', 'ruffle', 'cuff', 'facing', 'lining', 'elastik', 'loop'],
    dropChecked: 'par',
    errorMessage: '',
    isOpenTop: false,
    isOpenRight: false,
    heightArea: null
  }),
  computed: {
    disabledSaveButton () {
      if (this.dropChecked !== 'par') {
        if (this.inputValue || this.inputValue === 0) return false
        else return true
      } else {
        return this.numberEror || (!this.inputValue && this.inputValue !== 0) || !this.number
      }
    },
    val () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data
    },
    inputValue: {
      get () {
        if (this.value instanceof Array) return this.value.join()
        return this.value
      },
      set (val) {
        if (val.includes(',')) {
          this.value = val.split(',').map((el, index) => {
            if (!el.trim()) return el
            return Number(el.trim())
          })
        } else {
          this.value = [Number(val)]
        }
        this.inputHeight()
      }
    },
    inputNumber: {
      get () {
        return this.number
      },
      set (num) {
        this.number = num
        if (this.val[num] || this.val[num] === 0) {
          this.numberEror = true
          this.errorMessage = 'this params already exists'
        } else {
          this.numberEror = false
          this.errorMessage = ''
        }
      }
    }
  },
  methods: {
    inputHeight () {
      const textarea = document.querySelector('[am-params-textarea]')
      if (textarea.scrollHeight > textarea.clientHeight) {
        this.heightArea = textarea.scrollHeight
      }
    },
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    watchValue (event) {
      const regex = /^[0-9 ,]+$/
      const key = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(key)) {
        event.preventDefault()
        return false
      }
    },
    delPar (key) {
      delete this.val[key]
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    },
    add () {
      if (this.dropChecked !== 'par' && this.value !== null) {
        this.val[this.dropChecked] = this.value
        this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
        this.isEdit = false
      } else if (this.value !== null && this.number) {
        this.val[this.number] = this.value
        this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
        this.isEdit = false
      } else {
        this.errorMessage = 'all fields are required'
      }
    },
    reset () {
      this.number = null
      this.value = null
      this.dropChecked = 'par'
      this.numberEror = false
      this.errorMessage = ''
    },
    inputCheck (dropValue) {
      if (dropValue !== 'par') this.number = null
      this.dropChecked = dropValue
    },
    addParam () {
      this.reset()
      this.isEdit = 'add'
    },
    editParam (key) {
      this.reset()
      if (Number(key)) {
        this.number = key
        this.dropChecked = 'par'
      } else {
        this.dropChecked = key
        this.number = null
      }
      this.value = this.val[key]
      this.isEdit = 'edit'
      setTimeout(() => {
        this.inputHeight()
      }, 0)
    },
    showMode () {
      this.isOpenTop = false
      this.isOpenRight = false
      this.isActive = false
      this.isEdit = false
    },
    editMode () {
      this.isActive = true
      this.$emit('editing', this.data.index)
      if (this.$refs.params.getBoundingClientRect().y / window.innerHeight * 100 > 50) {
        this.isOpenTop = true
      }
      if (this.$refs.params.getBoundingClientRect().x / window.innerWidth * 100 > 50) {
        this.isOpenRight = true
      }
    }
  },
  mounted () {
    if (Array.isArray(this.data.data)) {
      this.val = {}
    }
  }
}
</script>

<style lang="scss">
[am-param-array-item] {
  [am-edit] {
    min-width: 20rem;
    [am-number-input] {
      -moz-appearance: textfield;
      &::-webkit-inner-spin-button {
        display: none;
      }
    }
    [am-buttons] {
      button:hover {
        ----border-color: var(--color--dark);
      }
    }
  }
}
</style>
